import { Box } from '@mui/material';
import styled from 'styled-components'

export const DashInfoBox = styled(Box)`
    display: flex;
    justify-content: start;
    gap: 50px;
`;

export const IconBox = styled(Box)`
    padding: 4px;
    border-radius: 5px;
    font-size: 20px;
    background: ${(props: any): any => props.color};
`;

export const GraphChip = styled(Box)`
    display: flex;
    gap: 10px;
    padding: 5px 15px;
    border-radius: 20px;
    color: ${(props: any): any => props.color};
    background: ${(props: any): any => props.bg};
`;
